import { MimeTypes } from 'models/Base64Data/MimeTypes';

export const fileHasPreview = (type: MimeTypes): boolean => [
  MimeTypes.APPLICATION_PDF,
  MimeTypes.IMAGE_JPEG,
  MimeTypes.IMAGE_JPG,
  MimeTypes.IMAGE_PNG,
].includes(type);
